var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMuteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.434 0.0991679C17.086 -0.0668319 16.676 -0.022832 16.376 0.219168L6.64799 8.00116H2C0.897999 8.00116 0 8.89916 0 10.0012V18.0012C0 19.1052 0.897999 20.0012 2 20.0012H6.64799L16.374 27.7831C16.556 27.9271 16.778 28.0011 17 28.0011C17.148 28.0011 17.296 27.9671 17.434 27.9011C17.78 27.7351 18 27.3851 18 27.0011V1.00117C18 0.617168 17.78 0.267168 17.434 0.0991679Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3252 10.4395C30.7393 9.85351 29.79 9.85351 29.2041 10.4395L27.3823 12.261L25.5605 10.4395C24.9746 9.85351 24.0254 9.85351 23.4395 10.4395C22.8535 11.0254 22.8535 11.9751 23.4395 12.5605L25.2612 14.3821L23.4395 16.2036C22.8535 16.7896 22.8535 17.7388 23.4395 18.3247C23.7324 18.6177 24.1162 18.7642 24.5 18.7642C24.8838 18.7642 25.2676 18.6177 25.5606 18.3247L27.3823 16.5031L29.2041 18.3247C29.4971 18.6177 29.8809 18.7642 30.2647 18.7642C30.6485 18.7642 31.0323 18.6177 31.3252 18.3247C31.9112 17.7388 31.9112 16.7895 31.3252 16.2036L29.5035 14.3821L31.3252 12.5605C31.9111 11.9751 31.9111 11.0254 31.3252 10.4395Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteIcon);
export default __webpack_public_path__ + "static/media/mute-icon.0ed833ec1f202102873bbd49f575e581.svg";
export { ForwardRef as ReactComponent };